
const VersionDisplay = () => {
  // Get version from environment variables
  const version = process.env.REACT_APP_VERSION || '0.1.0';
  
  // Get environment
  const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';
  
  // Get git commit hash if available
  const commitHash = process.env.REACT_APP_COMMIT_HASH || 'dev';
  
  return (
    <div style={{
      fontSize: '11px',
      fontFamily: 'monospace',
      color: '#9ca3af',
      textAlign: 'center',
      padding: '8px 0 0 0',
    }}>
      <span>v{version}</span>
      <span style={{ margin: '0 6px' }}>·</span>
      <span>{commitHash.substring(0, 7)}</span>
      <span style={{ margin: '0 6px' }}>·</span>
      <span>{environment}</span>
    </div>
  );
};

export default VersionDisplay;
